<template>
    <div class="modal">
        <div class="register-modal modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
                <register-form v-if="currentStep === 0" @next="nextStep"/>
                <register-tips v-if="currentStep === 1" @login="login"/>
            </div>
        </div>
    </div>
</template>

<script>
    import { POST_USER, USER_LOGIN } from '../../services/user'

    import RegisterForm from './steps/RegisterForm'
    import RegisterTips from './steps/RegisterTips'
    import {User} from "../../models/User";

    export default {
        name: "register-modal",
        components: { RegisterForm, RegisterTips},
        data() {
            return {
                currentStep: 0,
                formLogin: {}
            }
        },
        methods: {
            outsideClick() {
                if(event.target === event.currentTarget)
                    this.$emit('close');
            },
            validate(form) {
                let valid = true;
                for (const i in form.$children) {
                    let item = form.$children;
                    item[i].validate();
                    if(item[i].type == 'password_confirm' && (this.form.password != this.form.password_confirmation)){
                        item[i].errorMessage = 'As senhas digitadas não são iguais.'
                    }
                    if(item[i].errorMessage !== null)
                        valid = false;
                }
                return valid;
            },
            async handleSubmit(event) {
                event.preventDefault();
                this.loading = true;
                if(!this.validate(this)){
                    this.loading = false;
                    return false;
                }
                try{
                    const response = await POST_USER(this.form);
                    this.success = true;
                } catch(error) {

                } finally {
                    this.loading = false;
                }
            },
            nextStep(formLogin){
                this.formLogin = formLogin;
                this.currentStep += 1;
            },
            async login(){
              const response = await USER_LOGIN(this.formLogin);
              if(response.token){
                let user = new User();
                user.setUser(
                  response.data.name,
                  response.data.email,
                  response.token
                );
                let url_string = window.location.href;
                let url = new URL(url_string);
                let kit = url.searchParams.get("kit_number");
                if(!!kit && kit != '') window.location = `/perfil?kit_number=${kit}`;
                else window.location = "/perfil";
                
              }
            }
        },
        mounted() {

        }
    }
</script>

<style scoped>
    @import "./register-modal.scss";
    @import "./responsive.css";
</style>



// WEBPACK FOOTER //
// src/components/RegisterModal/RegisterModal.vue